import memoizeOne from 'memoize-one';
import type {
	FullPage,
	Section,
} from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';

/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */
const normalizeSection = (section: Section): Section => ({
	header: section?.header,
	pages: Array.isArray(section?.pages)
		? section.pages.map((page) => ({
				icon: page?.icon,
				route: page?.route,
				title: page?.title,
			}))
		: [],
});

export const toSections = memoizeOne((extension: FullPage): Section[] => {
	const { properties } = extension;

	// Only Custom UI supports subpages
	if (typeof properties.resource !== 'string') {
		return [];
	}
	// @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
	if (typeof properties.pages !== 'undefined' && properties.pages?.length) {
		// @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
		return [{ pages: properties.pages }].map(normalizeSection);
	}
	// @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
	if (typeof properties.sections !== 'undefined' && properties.sections?.length) {
		// @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
		return properties.sections.map(normalizeSection);
	}
	return [];
});
